<template>
    <div>
        <div :class="printerCls" :style="paperType">
            <div style="position: relative; width: 100%; height: 100%; padding: 0;">
                <!-- 标题 -->
                <div style="textAlign: center; paddingBottom: 5px; marginTop: 9px" :style="{marginRight: showBarcode ? '60px' : ''}">
                    <span :style="{borderBottom: '1px solid #000', fontSize: '16px', padding: thin ? '0' : '3px 6px', lineHeight: thin ? 1 : 1.5}">{{ showChainName ? chainName : '' }} {{ layout.danjuleixing }}</span>
                </div>
                 <!-- 条形码 -->
                <div class="barcode-container"  v-show="showBarcode" style="position: absolute; top: -25px; right: -0px;">
                    <img :src="drawBarcode()"/>
                </div>
                <!-- 页头 -->
                <div v-if="page === 1 || (page > 1 && layout.yetoudayin === '每页打印')" style="margin-top:10px">
                    <div
                        v-for="(item, index) in headItems"
                        :key="index"
                        :class="{'print-addr': item.key && alones.includes(item.key), 'print-ellipsis': true}"
                        :style="{ float: 'left', width: alones.includes(item.key) ? '100%' : '33.33%', height: thin ? height.thin : height.base, lineHeight: thin ? height.thin : height.base, fontSize: layout.zitidaxiao || '12px' }"
                    >
                        {{ tempFmt(item, item.key) }}
                    </div>
                </div>
                <!-- 表格 -->
                <div :class="[{'table-empty': printData.length === 0, 'table-thin': thin}, 'table-' + layout.zitidaxiao || '12px']" style="clear: both;padding: 3px 0;">
                    <vxe-table
                        ref="table"
                        :border="'none'"
                        :column-config="{resizable: true}"
                        :resizable-config="{minWidth: getMinWidth}"
                        :data="printData"
                        :header-cell-style="cellStyle"
                        :cell-style="cellStyle"
                        @resizable-change="changeWidth">
                        <vxe-column
                            v-for="(item, idx) in printColumns"
                            :key="idx"
                            :field="item.field"
                            :title="item.title"
                            :width="item.width"
                        ></vxe-column>
                    </vxe-table>
                </div>
                <!-- 页尾 -->
                <div v-if="page === pages || (page !== pages && layout.yeweidayin === '每页打印')">
                    <div
                        v-for="(item, index) in footItems"
                        :key="index"
                        :class="{'print-addr': item.key && alones.includes(item.key), 'print-ellipsis': true}"
                        :style="{ float: 'left', height: thin ? height.thin : height.base, lineHeight: thin ? height.thin : height.base , width: alones.includes(item.key) ? '100%' : '33.33%', fontSize: layout.zitidaxiao || '12px' }"
                    >
                        {{ tempFmt(item, item.key) }}
                    </div>
                </div>
                <!-- 页码 -->
                <div v-if="layout.dayinyema === 'true' || layout.dayinyema === true" :style="{ position: 'absolute', bottom: 0, right: 0, fontSize: layout.zitidaxiao || '12px' }">第{{ page || 1 }}页/共{{ pages || 1 }}页</div>
            </div>
        </div>
    </div>
</template>

<script>
import JsBarcode from 'jsbarcode'
export default {
    props: {
        // 表格数据
        list: {
            type: Array,
            default: () => [],
        },
        // 页头页脚
        print: {
            type: Object,
            default: () => {},
        },
        // 布局数据
        layout: {
            type: Object,
            default: () => ({}),
        },
        // 模拟填充数据
        mock: {
            type: Boolean,
            default: true,
        },
        // 页数
        pages: {
            type: Number,
            default: 1,
        },
        // 当前页数
        page: {
            type: Number,
            default: 1,
        },
        // 标识(区分同一页面不同Printer)
        identify: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            // 独占一行字段
            alones: ['shouhuodizhi', 'beizhu', 'peisongfahuodan.wuliugongsi'],
            height: {
                base: '5.5mm',
                thin: '4mm'
            },
            // 纸张大小
            paperSize: {
                A4纸: {
                    width: '210mm',
                    height: '296.5mm',
                    minHeight: '296.5mm',
                    padding: '5mm 10mm',
                },
                '一等分(针式)': {
                    width: '9.5in',
                    height: '11in',
                    minHeight: '11in',
                    padding: '6mm 23mm 6mm 18mm',
                },
                '二等分(针式)': {
                    width: '9.5in',
                    height: '5.5in',
                    minHeight: '5.5in',
                    padding: '6mm 25mm 6mm 15mm',
                },
                '三等分(针式)': {
                    width: '241mm',
                    height: '93mm',
                    minHeight: '93mm',
                    padding: '6mm 25mm 6mm 15mm',
                },
            },
            printData: [],
            printColumns: [],
            isChangeWidth: false,
            shopName: ''
        };
    },
    computed: {
        showBarcode() {
            return this.layout.dayintiaoma === 'true' || this.layout.dayintiaoma === true
        },
        thin() {
            return (this.layout || {}).dayinzhizhangleixing === '三等分(针式)'
        },
        printerCls() {
            return 'printer' + (this.identify || '')
        },
        // 纸张类型
        paperType() {
            const style = {
                color: '#000',
                overflow: 'hidden',
                border: this.mock ? '2px solid #d3d3d3' : 'none',
                zoom: this.mock ? ((this.layout ? this.layout.dayinzhizhangleixing : 'A4纸') === 'A4纸' ? '0.8' : '0.7') : 1,
                ...this.paperSize[this.layout ? this.layout.dayinzhizhangleixing : 'A4纸'],
                boxSizing: 'border-box',
                'page-break-after': 'always',
            };
            return style;
        },
        headItems() {
            return ((this.layout || {}).head || {}).items || [];
        },
        footItems() {
            return ((this.layout || {}).foot || {}).items || [];
        },
        showChainName() {
            return String(this.layout.jituanming) === 'true'
        },
        chainName() {
            return `${this.shopName || ((this.layout || {}).jituan || {}).name} -`
        }
    },
    watch: {
        'layout.meiyebiaogehangshu' () {
            this.drawList(this.list || [])
        },
        'layout.body.items' (items) {
            this.$nextTick(() => {
                this.drawColumns(items || [])
                this.drawList(this.list || [])
            })
        },
        'list' () {
            this.drawList(this.list || [])
        },
        'layout.hebinghang' () {
            this.drawList(this.list || [])
        },
        'layout.fenleixiaoji' () {
            this.drawList(this.list || [])
        },
    },
    methods: {
        cellStyle () {
            return {
                height: `${this.layout.hanggao || '6mm'} !important`,
                lineHeight: `${this.layout.hanggao || '6mm'} !important`
            }
        },
        // 页头页尾格式化
        tempFmt(item, path) {
            let label = '';
            let value = '';
            if (this.mock) {
                value = '：数据';
            } else if (path) {
                const pathArray = Array.isArray(path) ? path : path.match(/([^[.\]])+/g);
                let prop = pathArray.reduce((prevObj, key) => prevObj && prevObj[key], this.print);
                if (prop === undefined || prop === null) prop = ''
                if (/^-?\d+\.\d+$/.test(prop)) {
                    value = '：' + Number(Number(prop).toFixed(2));
                } else {
                    value = '：' + prop;
                }
            }

            if (item) {
                if (item.blank) {
                    if (typeof item.newLabel === 'string') {
                        label = item.newLabel;
                    } else {
                        label = '\xa0';
                    }
                } else if (item.key) {
                    if (typeof item.newLabel === 'string') {
                        label = item.newLabel + value;
                    } else {
                        label = item.label + value;
                    }
                } else {
                    label = item.label || '\xa0';
                }
            }
            return label;
        },
        /**
         * 获取表格表头数据
         */
        drawColumns (list) {
            this.printColumns = Array.from(list || [])
                .filter(v => v && (Array.isArray(v.key) ? v.key.length > 0 : typeof v.key === 'string' && v.key.trim()))
                .map((v) => {
                    const r = { field: v.key, title: v.newLabel || v.label || '' }
                    if (v.width) {
                        r.width = v.width
                        r.minWidth = v.width
                    }
                    return r
                })
            this.$refs.table.reloadColumn(this.printColumns)
        },
        getTotal(total = {}) {
            const danjuleixing = this.layout.danjuleixing
            if (danjuleixing === '销售报价单') {
                total.baojiashuliang = '数据'
                total.baojiajinehanshui = '数据'
            }
            if (danjuleixing === '配送发货单') {
                total.fahuoshuliang = '数据'
                total.fahuoshuliangkucun = '数据'
                total.fahuojinehanshui = '数据'
            } else if (danjuleixing === '配送收货单') {
                total.shouhuoshuliang = '数据'
                total.shouhuojinehanshui = '数据'
            } else if (danjuleixing === '配送订单') {
                total.caigoushuliang = '数据'
                total.kucunshuliang = '数据'
                total.caigoujinehanshui = '数据'
            } else if (danjuleixing === '配送返货单') {
                total.tuihuoshuliang = '数据'
                total.tuihuojinehanshui = '数据'
            } else if (danjuleixing === '采购订单') {
                total.caigoushuliang = '数据'
                total.caigoujinehanshui = '数据'
            } else if (danjuleixing === '采购收货') {
                total.shouhuoshuliang = '数据'
                total.shouhuojinehanshui = '数据'
                total.yishouhuojinehanshui = '数据'
            } else if (danjuleixing === '收发货差异处理单') {
                total.chayishuliang = '数据'
                total.chayijinehanshui = '数据'
            }
            return total
        },
        /**
         * 获取表格数据
         */
        drawList(list) {
            if (this.printColumns.length === 0 && this.layout.body.items.length) {
                this.drawColumns(this.layout.body.items)
            }
            this.printData = []
            const { page, layout, mock  } = this
            const { meiyebiaogehangshu, hangshu } = layout
            // 预览页
            if (mock) {
                const mockItem = this.printColumns.reduce((a, c) => {
                    a[c.field] = '数据'
                    return a
                }, {})
                this.printData = Array.from({length: meiyebiaogehangshu || 24}, (_, idx) => ({
                    ...mockItem,
                    xuhao: idx + 1
                }))
                // 处理mock合并行
                const isShowTotal = String(this.layout.hebinghang || false) === 'true'
                const isShowCategoryTotal = String(this.layout.fenleixiaoji || '不展示') === '展示'
                if (isShowCategoryTotal) {
                    const idx = isShowTotal ? this.printData.length - 2 : this.printData.length - 1
                    if (idx > 0) {
                        this.printData.splice(idx, 1, this.getTotal({xuhao: '分类小计'}))
                    }
                }
                if (isShowTotal && this.printData.length - 1 > 0) {
                    this.printData.splice(this.printData.length - 1, 1, this.getTotal({xuhao: '合计'}))
                }
                return
            }
            // 业务页
            let totalNum = 0
            list.forEach((v, idx) => {
                const item = this.printColumns.reduce((a, c) => {
                    if (c.field === 'xuhao') {
                        // 处理序号
                        if (v[c.field]) {
                            a[c.field] = v[c.field]
                        } else {
                            a[c.field] = (page - 1) * (meiyebiaogehangshu || 10) + idx + 1 - totalNum
                        }
                    } else {
                        const pathArray = Array.isArray(c.field) ? c.field : c.field.match(/([^[.\]])+/g)
                        let prop = pathArray.reduce((a1, c1) => a1 && a1[c1], v)
                        if (prop === undefined || prop === null) prop = ''
                        // 处理金额
                        if (/^-?\d+\.\d+$/.test(prop)) {
                            let fix = 2
                            fix = c.field.indexOf('jine') > -1 ? 2 : 6
                            a[c.field] = Number(Number(prop).toFixed(fix));
                        } else {
                            a[c.field] = prop
                        }
                    }
                    return a
                }, {})
                if (v.isTotal && v.totalName) {
                    totalNum += 1
                    item['isTotal'] = true
                    item['xuhao'] = v.totalName
                }
                this.printData.push(item)
            })
            if (!mock && hangshu === 'true' && meiyebiaogehangshu > list.length) {
                this.printData.push(...Array.from({length: meiyebiaogehangshu - list.length}, () => ({})))
            }
        },
        /**
         * 获取最小列宽
         */
        getMinWidth(v) {
            const minWidth = document.querySelectorAll('.vxe-table .vxe-cell--title')[v._columnIndex].offsetWidth
            return minWidth || 56
        },
        /**
         * 获取所有列的宽度
         */
        getColumnWidth () {
            if (this.isChangeWidth) {
                const zoom = Number(this.mock ? ((this.layout ? this.layout.dayinzhizhangleixing : 'A4纸') === 'A4纸' ? '0.8' : '0.7') : 1)
                const list = document.querySelectorAll('.vxe-table .vxe-header--column')
                if (list && list.length > 0) {
                    return Array.from(this.layout.body.items ||[], (o, i) => {
                        const width = Math.floor(list[i].getBoundingClientRect().width / zoom)
                        if (width) {
                            o.width = width
                        }
                        return o
                    })
                }
            }
            return JSON.parse(JSON.stringify(this.layout.body.items))
        },
        resetWidth () {
            this.drawColumns(((this.layout||{}).body||{}).items ||[])
            this.isChangeWidth = false
        },
        changeWidth () {
            this.isChangeWidth = true
            this.$forceUpdate()
        },
        changeColumns () {
           this.drawColumns(((this.layout||{}).body||{}).items ||[])
        },
        drawBarcode () {
            let value = ''
            if (this.mock) {
                value = 'test'
            } else {
                value = this.print.barcode || this.print.code || ''
            }
            let canvas = document.createElement("canvas");
            JsBarcode(canvas, value, {
                format: "CODE128", //选择要使用的条形码类型
                margin: 0,
                height: 50, //高度
                displayValue: false, //是否在条形码下方显示文字
            });
            return canvas.toDataURL('image/png')
        }
    },
    mounted(){
        this.drawColumns(((this.layout||{}).body||{}).items ||[])
        this.drawList(this.list ||[])
        if (this.$store.session.jigou) {
            this.shopName = this.$store.session.jigou.name
        }
    }
};
</script>
<style lang="less" scoped>
.printer * {
    font-family: "Microsoft YaHei", Arial, sans-serif !important;
    -webkit-font-smoothing: antialiased !important;
    -webkit-text-size-adjust: 100%;
    text-size-adjust: 100%;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    font-variant: tabular-nums;
    color: #000;
    -webkit-font-feature-settings: 'tnum', "tnum";
    font-feature-settings: 'tnum', "tnum";
}
.print-ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.print-addr {
    height: 2.5em !important;
    line-height: 1.25em !important;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    white-space: inherit;
}
/deep/ .vxe-table .vxe-header--column .vxe-resizable {
    opacity: 0 !important;
}
/deep/ .vxe-table .vxe-header--column,
/deep/ .vxe-table .vxe-body--column {
    color: #000 !important;
    padding: 0 !important;
    border: none;
    box-sizing: border-box;
    text-align: center !important;
    border-right: 1px solid #000 !important;
    border-top: 1px solid #000 !important;
}
/deep/ .vxe-table .vxe-header--column {
    border-top: 1px solid #000 !important;
}
/deep/ .vxe-table .vxe-header--column:last-child,
/deep/ .vxe-table .vxe-body--column:last-child {
    border-right: 1px solid #000 !important;
}

/deep/ .vxe-table .vxe-cell {
    padding: 0;
    overflow: hidden !important;
    text-align: center !important;
    white-space: nowrap !important;
    box-sizing: border-box;
}


/deep/ .table-thin .vxe-table .vxe-header--column,
/deep/ .table-thin .vxe-table .vxe-body--column,
/deep/ .table-thin .vxe-table .vxe-cell {
    height: 4.5mm !important;
    line-height: 4.5mm !important;
}

/deep/ .vxe-table .vxe-header--column:first-child,
/deep/ .vxe-table .vxe-body--column:first-child{
    border-left: 1px solid #000 !important;
}
/deep/ .vxe-table .vxe-body--row:first-child .vxe-body--column {
    border-top: 1px solid #000 !important;
}
/deep/ .vxe-table .vxe-body--row:last-child .vxe-body--column {
    border-bottom: 1px solid #000 !important;
}

/deep/ .table-empty .vxe-table .vxe-header--column {
    border-bottom: 1px solid #000 !important;
}

/deep/ .table-12px * {
    font-size: 12px !important;
}
/deep/ .table-13px * {
    font-size: 13px !important;
}
/deep/ .table-14px * {
    font-size: 14px !important;
}
/deep/ .table-15px * {
    font-size: 15px !important;
}
/deep/ .table-16px * {
    font-size: 16px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/web/xtsz/dymbsz/mblb/PrintForm.vue?1fb6bb7c